type SourceChapter = {
  chapter_guid: string;
  chapter_kind?: string;
  plain_word_count?: number;
};

// Book detail responses classify legacy HTML on read, including blank page breaks.
// Missing classification is not evidence that a chapter is empty.
export const isContentBearingChapterRow = (chapter: SourceChapter): boolean => {
  if (chapter.chapter_kind === 'structural') return false;
  if (typeof chapter.plain_word_count === 'number') return chapter.plain_word_count > 0;
  return true;
};

export const getMissingProofreadTranslationGuids = (
  chapters: readonly SourceChapter[],
  hasTranslation: (chapterGuid: string) => boolean,
): string[] => chapters
  .filter(isContentBearingChapterRow)
  .filter(chapter => !hasTranslation(chapter.chapter_guid))
  .map(chapter => chapter.chapter_guid);
